var React = require('react');

function EnCA (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h6.783l5.306 1.87L17.217 0H24v24h-6.783l-5.062-2.123L6.788 24H0V0Z","fill":"#D80027","key":0}),React.createElement("path",{"d":"M6.783 0h10.434v24H6.783V0Z","fill":"#fff","key":1}),React.createElement("path",{"d":"m14.086 13.566 2.086-1.05-1.04-.516v-1.045L13.044 12l1.04-2.086h-1.04L12 8.344l-1.045 1.565h-1.04l1.04 2.086-2.086-1.045V12l-1.04.52 2.085 1.046-.525 1.045h2.095v1.56h1.032v-1.56h2.09l-.52-1.045Z","fill":"#D80027","key":2})]);
}

EnCA.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = EnCA;

EnCA.default = EnCA;
